import "./Switch.scss";
import { useId } from "react";

export type SwitchProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    /** Primary label (shown beside the track). */
    label: React.ReactNode;
    disabled?: boolean;
    /** Optional stable id for the switch button (for `aria-labelledby`). */
    id?: string;
    /** Tooltip on the control. */
    title?: string;
    className?: string;
};

/**
 * Accessible toggle (Material-style switch): label + sliding thumb on a track.
 * `checked` false = first mode; true = second mode — callers map semantics (e.g. click spawn vs drag paint).
 */
export function Switch({
    checked,
    onChange,
    label,
    disabled,
    id: idProp,
    title,
    className,
}: SwitchProps) {
    const uid = useId();
    const buttonId = idProp ?? `switch-${uid}`;

    return (
        <div
            className={["panel-switch", className].filter(Boolean).join(" ")}
            title={title}
        >
            <label className="panel-switch__label">
                <span className="panel-switch__text">{label}</span>
                <button
                    id={buttonId}
                    type="button"
                    role="switch"
                    aria-checked={checked}
                    disabled={disabled}
                    className="panel-switch__button"
                    onClick={() => !disabled && onChange(!checked)}
                >
                    <span className="panel-switch__track" aria-hidden>
                        <span className="panel-switch__thumb" />
                    </span>
                </button>
            </label>
        </div>
    );
}
